import { LocaleIdentifier } from '@repo/markets/types'
import { NavigationQueryResult } from '@repo/sanity/types'
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@repo/ui/components/accordion'
import type { PortableTextBlock } from 'next-sanity'
import { FunctionComponent } from 'react'
import PortableText from '../../text/PortableText'

interface Props {
  locale: LocaleIdentifier
  navigation: NavigationQueryResult
}

const CartAccordion: FunctionComponent<Props> = ({ locale, navigation }) => {
  if ((navigation?.cartSettings?.accordion || []).length === 0) {
    return null
  }

  // Get accordion _key[] that sets which items are open by default
  const defaultValue = navigation?.cartSettings?.accordion?.flatMap((accordionItem) => (accordionItem.openByDefault ? accordionItem._key : []))

  return (
    <Accordion className='mb-0 mt-auto w-full text-black' type='multiple' defaultValue={defaultValue}>
      {navigation?.cartSettings?.accordion?.map((accordionItem) => (
        <AccordionItem key={accordionItem._key} value={accordionItem._key} variant='lightStatic' rounded={false}>
          <AccordionTrigger>{accordionItem.title}</AccordionTrigger>
          <AccordionContent>
            <PortableText value={accordionItem.content as PortableTextBlock[]} locale={locale} />
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  )
}

export default CartAccordion
